var keycloak;
function checkLogin(returnUrl, isAuthenticated) {
    keycloak = new Keycloak("/keycloak.json");
    if (isAuthenticated) {
        keycloak.init();
        $(".logout").click(function () {
            keycloak.logout({
                redirectUri: this.dataset.siteLogout+'?returnUrl='+ window.location.href,
            });
        });
    } else {
        keycloak.init({
            onLoad: 'check-sso',
            silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
        }).then(function (authenticated) {
            if (authenticated) {
                $(location).attr("href", "/ingresar-sso?returnUrl=" + returnUrl);
            }
        }).catch(function () {
        });
    }
    
}